module.exports = __webpack_public_path__ + "static/media/ic_logo.52ea39ec.svg";